export default {
  translate(errorCode) {
    const messages = {
      member_is_active: {
        title: 'Membership already active',
        message: 'Your membership is already active. Please email us at <a href="mailto:help@mentalhealthacademy.co.uk">help@mentalhealthacademy.co.uk</a> for further assistance.'
      },
      cannot_decode_hashed_id: {
        message: 'Message about wrong promo code'
      },
      charge_failed: {
        message: 'Unfortunately your payment attempt was declined. Please try again and if the issue persists, email us for additional support. Thank you.'
      },
      no_referral: {
        title: 'No referral heading here',
        message: 'No referral are passed....'
      },
      email_has_been_taken: {
        title: 'Email has been taken',
        message: `Please use an alternative email address to complete your registration or <a href="mailto:help@mentalhealthacademy.co.uk">contact us</a> for further assistance`
      },
      password_is_invalid: {
        title: 'Password is incorrect',
        message: 'Please try again or reset your password.'
      },
      member_enrolled_course_already: {
        title: 'Looks like you already own this course',
        message: 'Please check your Learning Portal under Credential Courses > View Courses to access this course. If you require further assistance, please contact us at <a href="mailto:help@mentalhealthacademy.co.uk">help@mentalhealthacademy.co.uk</a>.'
      },
      service_unavailable: {
        title: `We're sorry for the inconvenience...`,
        message: 'We had an unexpected problem completing your registration. Please contact our friendly support team on <a href="mailto:help@mentalhealthacademy.co.uk">help@mentalhealthacademy.co.uk</a> for further assistance. Thank you for your patience.'
      },
      issuer_declined: {
        title: 'Issuer declined',
        message: 'Unfortunately your payment attempt was declined. Please try again and if the issue persists, email us for additional support. Thank you.'
      },
      risk_declined: {
        title: 'Risk declined',
        message: 'Unfortunately your payment attempt was declined. Please try again and if the issue persists, email us for additional support. Thank you.'
      },
      card_brand_not_supported: {
        title: 'Card Type Not Supported',
        message: 'This payment card type is currently not supported by our form, please try again with a different card or if the issue persists, email us for additional support. Thank you.'
      }
    }

    return messages[errorCode] || {
      title: 'Something has gone wrong...',
      message: 'Please contact at help@mentalhealthacademy.co.uk'
    }
  }
}
